/* import __COLOCATED_TEMPLATE__ from './if-else-statement-editor.hbs.js'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
let IfElseStatementEditor = (_class = class IfElseStatementEditor extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "isEditing", _descriptor, this);
  }
  get editorState() {
    return this.args.composer.state.prosemirrorState;
  }
  get isVisible() {
    let nodeSchema = this.editorState.schema.nodes.ifElseStatement;
    return nodeSchema && this.node?.type === nodeSchema;
  }
  get node() {
    let selection = this.editorState.selection;
    return selection?.node;
  }
  startEditing() {
    this.args.composer.disableInteractivity();
    this.isEditing = true;
  }
  stopEditing() {
    this.isEditing = false;
    this.args.composer.enableInteractivity();
  }
  update(block) {
    this.args.composer.config.analytics?.trackAnalyticsEvent('edited', {
      block_type: 'ifElseStatement'
    });
    this.args.composer.commands.updateSelectedNode({
      predicatesBlocksPairs: block.predicatesBlocksPairs,
      fallbackBlocks: block.fallbackBlocks
    });
  }
  deleteSelection() {
    this.args.composer.commands.deleteSelection();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isEditing", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "startEditing", [action], Object.getOwnPropertyDescriptor(_class.prototype, "startEditing"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stopEditing", [action], Object.getOwnPropertyDescriptor(_class.prototype, "stopEditing"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "update", [action], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteSelection", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteSelection"), _class.prototype)), _class);
export { IfElseStatementEditor as default };